import { Container, Typography } from "@mui/material";

/**
 * Pantalla que se muestra cuando `agencia.activo` es false.
 * Se renderiza desde `ProtectedRoute`, que es el único lugar que decide la suspensión.
 */
export default function ServiceSuspended() {
  return (
    <Container maxWidth={false} sx={{ mt: 1, p: 0 }}>
      <Typography sx={{ textAlign: "center" }}>
        Servicio no disponible por el momento
      </Typography>
    </Container>
  );
}
